export enum TableLayoutType {
  COMPONENT_TEMPLATE = 'component_template',
  COSTING_PROFILE = 'costing_profile',
  COSTING_PROFILE_VENDOR_QUOTES = 'costing_profile_vendor_quotes',
  CUSTOMER_CONTACT = 'customer_contact',
  CUSTOMER_CONTACT_GROUP = 'customer_contact_group',
  CUSTOMER_CONTACT_GROUP_CONTACT = 'customer_contact_group_contact',
  CUSTOMER_CONTACT_GROUP_LOCATION = 'customer_contact_group_location',
  CUSTOMER_LOCATION = 'customer_location',
  CUSTOMER_ORDER = 'customer_order',
  CUSTOMER_ORDER_PART = 'customer_order_part',
  CUSTOMER_QUOTE = 'customer_quote',
  CUSTOMER_QUOTE_COSTING = 'customer_quote_costing',
  CUSTOMER_QUOTE_PART = 'customer_quote_part',
  ELEMENT_TEMPLATE = 'element_template',
  ELEMENT_TEMPLATE_PART = 'element_template_part',
  EXTRACTOR_VENDOR_MAPPING = 'extractor_vendor_mapping',
  JOB = 'job',
  JOB_CUSTOMERS = 'job_customers',
  JOB_ELEMENT = 'job_element',
  JOB_LOG = 'job_log',
  JOB_PART = 'job_part',
  JOB_VENDORS = 'job_vendors',
  PART_BOM_ITEMS = 'part_bom_items',
  PART_FINDER_ATTRIBUTE = 'part_finder_attribute',
  PART_FINDER_CATALOG = 'part_finder_catalog',
  PART_FINDER_FAMILY = 'part_finder_family',
  PART_FINDER_FAMILY_PART = 'part_finder_family_part',
  PART_FINDER_PRODUCT_TYPE = 'part_finder_product_type',
  PART_FINDER_REEL = 'part_finder_reel',
  PART_INVENTORY = 'part_inventory',
  PART_QUOTE_HISTORY = 'part_quote_history',
  PART_SALES_HISTORY = 'part_sales_history',
  PRICING_PROFILE = 'pricing_profile',
  PRICING_PROFILE_ACCESS = 'pricing_profile_access',
  PRICING_PROFILE_ADMIN_USERS = 'pricing_profile_admin_users',
  PRICING_PROFILE_COSTING_CALCULATION = 'pricing_profile_costing_calculation',
  PRICING_PROFILE_PART_NUMBER = 'pricing_profile_part_number',
  PRICING_PROFILE_RULE = 'pricing_profile_rule',
  PROJECT = 'project',
  PROJECT_CUSTOMER_ORDER = 'project_customer_order',
  PROJECT_CUSTOMER_QUOTE = 'project_customer_quote',
  PROJECT_EXTERNAL_CUSTOMER = 'project_external_customer',
  PROJECT_JOB = 'project_job',
  PROJECT_PRICING_PROFILE = 'project_pricing_profile',
  PROJECT_USER = 'project_user',
  PROJECT_VENDOR_ORDER = 'project_vendor_order',
  PROJECT_VENDOR_QUOTE = 'project_vendor_quote',
  QUOTE_PART_TRADE_AGREEMENTS = 'quote_part_trade_agreements',
  SUBMIT_ORDER_LOG = 'submit_order_log',
  UOM_CONVERSION_AUDIT = 'uom_conversion_audit',
  VENDOR_CONTACT = 'vendor_contact',
  VENDOR_CONTACT_GROUP = 'vendor_contact_group',
  VENDOR_CONTACT_GROUP_CONTACT = 'vendor_contact_group_contact',
  VENDOR_CONTACT_GROUP_LOCATION = 'vendor_contact_group_location',
  VENDOR_LOCATION = 'vendor_location',
  VENDOR_ORDER = 'vendor_order',
  VENDOR_ORDER_PART = 'vendor_order_part',
  VENDOR_QUOTE = 'vendor_quote',
  VENDOR_QUOTE_ATTACH_EXISTING = 'vendor_quote_attach_existing',
  VENDOR_QUOTE_IMPORT_LOG = 'vendor_quote_import_log',
  VENDOR_QUOTE_PART = 'vendor_quote_part',
}
